import { Box } from '@material-ui/core';
import { makeStyles, Theme } from '@material-ui/core/styles';
import { Layout, useUserStore } from '@roc/feature-app-core';
import { Tabs } from '@roc/ui';
import { observer } from 'mobx-react';
import { CounterPartyExpensesTab } from '../types/types';
import { useProtectiveAdvancesStore } from '../hooks/useProtectiveAdvancesStore';
import { ReceivablesDashboard } from './receivables/receivablesDashboard';
import { PayablesDashboard } from './payables/payablesDashboard';
import { ReceivablesBillsDashboard } from './receivablesBills/receivablesBillsDashboard';
import { VendorPaymentsDashboard } from './vendorPayments/vendorPaymentsDashboard';
import { useEffect } from 'react';

const TABS = [
  {
    value: CounterPartyExpensesTab.PAYABLE,
    label: 'Payables',
  },
  {
    value: CounterPartyExpensesTab.RECEIVABLE,
    label: 'Receivables',
  },
  {
    value: CounterPartyExpensesTab.BILL,
    label: 'Receivables - Bills',
  },
  {
    value: CounterPartyExpensesTab.VENDOR_PAYMENT,
    label: 'Vendor - Payments',
  },
];

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    maxWidth: '1800px',
  },
  paper: {
    boxShadow: 'none !important',
    border: '1px solid #cdcdcd',
    padding: '0px',
    borderRadius: '0 !important',
  },
}));



export const ProtectiveAdvancesDashboard = observer(() => {
  const classes = useStyles();
  const {
    protectiveAdvancesStore,
    protectiveAdvancesStore: { tab }
  } = useProtectiveAdvancesStore();
  const { userStore } = useUserStore();

  useEffect(() => {
    userStore.getUserInfoAndEntitlements();
  }, [])

  return (
    <Layout title="Protective Advances" containerClass={classes.container}>
      <Box pb={2}>
        <Tabs
          selectedTab={TABS.findIndex(t => t.value == tab)}
          tabs={Object.values(TABS)}
          onTabChange={(e, i) => protectiveAdvancesStore.setTab(TABS[i].value)}
        />
      </Box>
      <Box display="flex" flexDirection="column" height="100%">
        <Box flex={1}>
          {tab === CounterPartyExpensesTab.PAYABLE && <PayablesDashboard />}
          {tab === CounterPartyExpensesTab.RECEIVABLE && <ReceivablesDashboard />}
          {tab === CounterPartyExpensesTab.BILL && <ReceivablesBillsDashboard />}
          {tab === CounterPartyExpensesTab.VENDOR_PAYMENT && <VendorPaymentsDashboard />}
        </Box>
      </Box>
    </Layout>
  );
});
